// extracted by mini-css-extract-plugin
export default {"kvmTip":"app-react-edge-edge-devices-ListView-EdgeDevicesDatatable-EdgeDevicesDatatable-module__kvm-tip"};